import React, { useEffect, useState, useContext, useRef } from "react";
import PropTypes from "prop-types";
import Tools from "./JNSTools";
import DashboardProjectDocuments from "./DashboardProjectDocuments_sfgrid";
import { CredsContext, HelpModeContext } from "./Contexts";

function DashboardProjectDocumentsContainer(props) {
  const [attachmentArray, setAttachmentArray] = useState();
  const creds = useContext(CredsContext).creds;
  const workspaceid = useRef();

  const storedDocs = sessionStorage.getItem("dashboardAttachmentList");

  useEffect(() => {
    if (!storedDocs) {
      //props.waitHandler(true); uncommenting this causes the page to refresh over and over
      const authString = Tools.getXmlBodyAuthString(creds);
      const urlString = Tools.getInstanceUrl(creds);
      const requestString =
        authString +
        '<Read type="Workspacelink" method="equal to" limit="1"><Workspacelink><recordid>' +
        props.projectObject.id +
        "</recordid></Workspacelink></Read></request>";

      Tools.fetchPost(requestString, urlString, "Workspacelink").then(
        (wsLinkResponse) => {
          const wsLinkArray = Tools.xmlToArray(wsLinkResponse.xml);
          if (wsLinkArray.length > 0) {
            workspaceid.current = wsLinkArray[0].workspaceid;
            const attachmentRequestString =
              authString +
              '<Read type="Attachment" method="equal to" limit="1000"><Attachment><workspaceid>' +
              wsLinkArray[0].workspaceid +
              "</workspaceid></Attachment></Read></request>";
            Tools.fetchPost(
              attachmentRequestString,
              urlString,
              "Attachment",
            ).then((attachmentResponse) => {
              sessionStorage.setItem(
                "dashboardAttachmentList",
                JSON.stringify(Tools.xmlToArray(attachmentResponse.xml)),
              );
              setAttachmentArray(Tools.xmlToArray(attachmentResponse.xml));
              //props.waitHandler(false);
            });
          } else {
            props.waitHandler(false);
          }
        },
      );
    } else {
      setAttachmentArray(JSON.parse(storedDocs));
    }
  }, []);

  return (
    <DashboardProjectDocuments
      projectObject={props.projectObject.current}
      waitHandler={props.waitHandler}
      panelLocked={props.panelLocked}
      removePanel={props.removePanel}
      panelId={3}
      attachmentArray={attachmentArray}
    />
  );
}

export default DashboardProjectDocumentsContainer;

DashboardProjectDocumentsContainer.propTypes = {
  waitHandler: PropTypes.func,
  projectObject: PropTypes.object,
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
};
